// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  overflow-x: hidden;
}

.overallVideoAnnotatorContainer {
  font-family: none;
  /* .toggle{
    background-color:rgb(185, 185, 185);
    color: yellow;
    height: 2em;
    width: 2em;
    text-align: center;
    line-height: 2em;
    vertical-align: middle;
    border-radius: 100em;
    font-size: x-large;
    z-index: 100;
    position: fixed;
    bottom: 1em;
    right: 1em;
    cursor: pointer;
    transition: background-color .2s ease;
    -webkit-touch-callout: none; 
    -webkit-user-select: none; 
     -khtml-user-select: none; 
       -moz-user-select: none; 
        -ms-user-select: none;
            user-select: none; 
  
  } */
  /* 
  .toggle:hover{
    transition: background-color .2s ease;
    background-color:rgb(146, 146, 146);
  } */

  .initialLoader {
    position: fixed;
    left: 49%;
    top: 50%;
    width: 100%;
    height: 100%;
    z-index: 9999;
  }

  /* Styling for Editing */
  .wrapper {
    width: 80%;
    margin-left: 12.5%;
    -webkit-touch-callout: none;
    /* iOS Safari */
    -webkit-user-select: none;
    /* Safari */
    /* Konqueror HTML */
    /* Old versions of Firefox */
    /* Internet Explorer/Edge */
    user-select: none;
    /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
  }

  .videoAndLabelWrapper {
    display: flex;
    width: 100%;
  }

  .video-info-div {
    width: 100%;
    word-break: break-word;
  }

  .videoContainer {
    display: flex;
    flex-direction: column;
    width: 95%;
    border: 1px solid gray;
  }

  .controller_wrapper {
    float: left;
    width: 100%;
    overflow: auto;
    margin-left: 1%;
    height: -webkit-fill-available;
    margin-top: 1%;
    -webkit-touch-callout: none;
    /* iOS Safari */
    -webkit-user-select: none;
    /* Safari */
    /* Konqueror HTML */
    /* Old versions of Firefox */
    /* Internet Explorer/Edge */
    user-select: none;
    /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
  }

  .label_contrll_wrapper {
    width: 92%;
    margin-left: 1%;
    margin-right: 3%;
    display: flex;
    margin-top: 2px;
    height: -webkit-fill-available;
    /* height: 239px;
      overflow: auto; */
  }


  @media screen and (max-width: 1980px) {
    .labelcontainer {
      width: 15%;
      float: left;
      margin-top: 0%;
      height: 100%;
      /* margin-bottom: 5%; */
      text-align: center;
    }
  }

  @media screen and (max-width: 1466px) {
    .labelcontainer {
      width: 15%;
      float: left;
      margin-top: 30%;
      height: 100%;
      /* margin-bottom: 5%; */
    }
  }


  @media screen and (max-width: 1980px) {
    .labelcontainer-for-nav-bar {
      width: 15%;
      float: left;
      margin-top: 0%;
      height: 100%;
      /* margin-bottom: 5%; */
      text-align: center;
      display: flex;
      flex-direction: column;
      gap: 12px;
      padding: 12px;
    }
  }

  @media screen and (max-width: 1466px) {
    .labelcontainer-for-nav-bar {
      width: 50px;
      background-color: #d5d8d8;
      float: left;
      height: 98vh;
      display: flex;
      flex-direction: column;
      gap: 12px;
      padding: 4px;
      border-radius: 0px 10px 10px 0px;
      margin-top: 1vh;
      /* margin-bottom: 5%; */
    }
  }

  .sidebar-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #ffffff;
    padding: 8px 0;
    width: 60px;
    float: left;
    height: 100vh;
    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
    border-radius: 12px;
    z-index: 100;
    position: absolute;
  }

  .sidebar-icon {
    background: none;
    border: none;
    padding: 3px 17px;
    margin: 6px 0;
    font-size: 18px;
    color: #5a5a5a;
    cursor: pointer;
    border-radius: 8px;
    transition: background-color 0.2s ease, color 0.2s ease;
  }

  .sidebar-icon:hover,
  .sidebar-icon:focus {
    background-color: #eaf3ff;
    color: #1976d2;
  }

  .sidebar-icon:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  .sidebar-icon-svg {
    width: 20px;
    height: 20px;
  }

  @media screen and (max-width: 1400px) {
    .sidebar-bottom-icon {
      margin-top: auto;
      /* This pushes it to the bottom */
    }
  }


  .nav-icon-button {
    background: none;
    border: none;
    font-size: 18px;
    padding: 10px;
    cursor: pointer;
    transition: background 0.2s ease;
  }

  .nav-icon-button:hover {
    background-color: #e0e0e0;
    border-radius: 8px;
  }

  .roi-dropdown {
    width: 100%;
    margin-top: 4px;
  }


  .containeForROISelectorModal {
    position: absolute;
    width: 100%;
    left: 0px;
    height: 99%;
    z-index: 201;
  }

  .roiContainer {
    position: absolute;
    margin-top: -10%;
  }

  .roiContainerSlider {
    margin-top: -13%;
    z-index: 212;
    display: flex;
    position: absolute;
    width: 179px;
  }

  .export_frame_button_div {
    .export_frame_button {
      min-width: 180px;
      border-radius: 3px;
      height: 39px;
      background-color: #038eff;
      border: 0.5px solid #038eff;
      color: white;
    }

    .export_frame_button:hover {
      background-color: #2980b9;
      color: white;
    }
  }

  .export_frame_button_div {
    margin-top: -16.5%;
    z-index: 212;
    display: flex;
    position: absolute;
  }

  @media screen and (min-width: 1480px) {
    .export_frame_button_div {
      margin-top: -10.5%;
      z-index: 212;
      display: flex;
      position: absolute;
    }

    .roiContainerSlider {
      margin-top: -8%;
      z-index: 212;
      display: flex;
      position: absolute;
      width: 179px;
    }

  }



  .roiswitch {
    width: 60px;
    height: 34px;
    outline: none;
    scale: 0.7;
    margin-top: -5px;
  }

  .addROIButton {
    border: none;
    padding: 6px;
    margin-right: 2vh;
    border-radius: 3px;
    width: 100%;
    background-color: #038eff;
    border: 0.5px solid #038eff;
    color: white;
  }

  .addROIButton:hover {
    background-color: #2980b9;
    color: white;
  }

  .roiInfoIcon {
    margin-top: 11px;
  }

  .croppedVideoContainer {
    /* margin-top: -71vh; */
    position: absolute;
    z-index: 211
  }

  @media screen and (max-width: 1980px) {
    .roiSplitter {
      position: absolute;
      margin-top: 13vh;
      min-width: 257px;
      height: 0px;
      cursor: pointer;
      margin-bottom: -6px;
      border-radius: 4px;
      z-index: 202;
      border: 1px solid black;
    }

    .croppedVideoContainer {
      /* margin-top: -71vh; */
      position: absolute;
      z-index: 211
    }
  }

  @media screen and (max-width: 1466px) {
    .roiSplitter {
      position: absolute;
      margin-top: 13vh;
      min-width: 185px;
      height: 0px;
      cursor: pointer;
      margin-bottom: -6px;
      border-radius: 4px;
      z-index: 202;
      border: 1px solid black;
    }

    .croppedVideoContainer {
      /* margin-top: -71vh; */
      position: absolute;
      z-index: 211
    }
  }




  @media screen and (max-width: 1980px) {
    .roiControllButtonsContainer {
      position: absolute;
      margin-top: -7.2%;
      margin-left: -12.55%;
      z-index: 202;
      display: flex;
      width: 278px;
    }
  }

  @media screen and (max-width: 1466px) {
    .roiControllButtonsContainer {
      position: absolute;
      margin-top: -10.5%;
      margin-left: -12%;
      z-index: 202;
      display: flex;
      width: 178px;
    }
  }


  .roiButtons {
    margin-top: 11px;
    display: block;
    width: 100%;
    border-radius: 0px;
    border: 1px;
    padding: 7px 0px;
  }

  .deletebutton {
    background: #e74c3c;
    border: #e74c3c;
    color: white;
    border-radius: 3px;
    margin-right: -3px;
    margin-left: 2px;
  }

  .deletebutton:hover,
  .deletebutton:active {
    background: #c0392b;
    color: white;
  }

  .previewsubmitButton {
    background: #3498db;
    border: #3498db;
    min-width: 140px;
    color: white;
    margin-right: 4px;
    border-radius: 3px;
  }

  .previewsubmitButton:hover,
  .previewsubmitButton:active {
    background: #2980b9;
    color: white;
  }



  .roiSubmitButton {
    background: #16a436;
    color: white;
    min-width: 140px;
    margin-right: 4px;
    border-radius: 3px;
  }

  .roiSubmitButton:hover,
  .roiSubmitButton:active {
    background: #0b7323;
    color: white;
  }



  .seperatorLine {
    border: 1px solid #0072cf;
    margin-top: 25px;
  }

  @media screen and (max-width: 1980px) {
    .seperatorLine {
      position: absolute;
      z-index: 106 !important;
    }

    .savedROISelector {
      position: absolute;
      margin-top: 8.7vh;
      min-width: 251px;
      height: 30px;
      cursor: pointer;
      margin-bottom: -6px;
      border-radius: 4px;
      border: 1px solid #ced4da;
      font-size: 14px;
      z-index: 202;
    }

  }

  @media screen and (max-width: 1466px) {
    .seperatorLine {
      position: absolute;
      z-index: 106 !important;
    }

    .savedROISelector {
      position: absolute;
      margin-top: 7vh;
      min-width: 180px;
      height: 30px;
      cursor: pointer;
      margin-bottom: -6px;
      border-radius: 4px;
      border: 1px solid #ced4da;
      font-size: 14px;
      z-index: 202;
    }
  }

  .remaining-time-container {
    position: absolute;
    margin-top: 4%;
  }

  .remaining-time {
    color: #dc3545;
  }

  .video-speed-controller {
    padding: 2px;
    border-radius: 4px;
    cursor: pointer;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    width: 61px;
    font-size: 12px;
    height: 40px;
    margin-right: -28px;
  }

  /* .video-speed-controller:-ms-expand {
    display: none;
} */
  .videoAnnotateLabelContainer {
    margin-top: 4%;
    overflow-y: auto;
    height: 100%;
    scrollbar-width: none;
  }

  .playbackMarkedItems {
    margin-top: 35px !important
  }

  @media screen and (max-width: 1980px) {
    .playbackMarkedItems {
      margin-top: 46px !important
    }
  }

  @media screen and (max-width: 1466px) {
    .playbackMarkedItems {
      margin-top: 35px !important
    }
  }

  .onscrollControllContainer {
    height: 41px;
    margin-bottom: 0px;
  }

  .video {
    width: 100%;
    cursor: pointer;
    height: 69vh !important;
    border-radius: 1em;
    border-radius: 10px 10px 0px 0px;
  }

  .videoplayer {
    cursor: pointer;
    z-index: 210;
    position: absolute;
    margin-top: 1px;
  }

  .seconsTimelinetopcontroller {
    margin-top: -5px;
    font-size: 12px;
  }

  .seconsTimeline {
    margin-top: 2px;
  }

  .output {
    display: flex;
    margin-top: 1rem;
    /* margin-left: 24px; */
    margin-right: 24px;
    margin-bottom: 2rem;
  }

  .seconsTimelineFrames {
    text-align: left;
    width: 5px;
    margin-top: 10px;
    list-style: none;
    overflow: visible;
    cursor: pointer;
  }

  .seconsTimelineFrames p {
    width: 5px;
    margin-bottom: -25px;
    text-align: center;
  }

  .seconsTimelineFrames .hmsparagraph {
    width: 5px;
    margin-top: 19px;
    text-align: center;
  }

  /* .seconsTimelineFrames:hover{
      background-color: yellow;
      scale: 2 1;
    } */

  /* .secondmeasurement{
  
    } */
  .secondmeasurement:hover {
    background-color: yellow;
    scale: 1.1;
  }

  .secondsDisplay {
    position: relative;
    z-index: 5 !important;
  }

  .secondsDisplayonHover {
    position: absolute;
    z-index: 5 !important;
    margin-top: -10px;
    font-size: 18px;
  }

  .secondsHoverLast {
    margin-left: -2rem;
  }

  .play_back_timer_frame_control {
    position: absolute !important;
    margin-top: -1.5rem !important;
    overflow-x: initial !important;
    overflow-y: auto !important;
    border-radius: 0px !important;
    padding-left: 0px;
    padding-right: 0px;
    height: 60px !important;

    ::-webkit-scrollbar {
      width: 3px;
      height: 3px
    }

    ::-webkit-scrollbar-button {
      background: #ccc
    }

    ::-webkit-scrollbar-track-piece {
      background: #eee
    }

    ::-webkit-scrollbar-thumb {
      background: #888
    }
  }

  .play_back_timer_frame_control::-webkit-scrollbar {
    width: 3px;
    height: 3px
  }

  .play_back_timer_frame_control::-webkit-scrollbar-button {
    background: #ccc
  }

  .play_back_timer_frame_control::-webkit-scrollbar-track-piece {
    background: #eee
  }

  .play_back_timer_frame_control::-webkit-scrollbar-thumb {
    background: #888
  }

  ​ .seekableTimeFrame {
    margin-left: 15px;
    padding-right: 15px;
  }

  .frameSelectorTime {
    display: none;
  }

  .frameSelectorTime:hover {
    display: block;
  }

  .timeDifference {
    /* margin-left: 24px; */
  }

  .framesImgViewer {
    width: 47px;
    height: 25px;
  }

  .imgTopCentre {
    margin: auto;
  }

  .framesImgViewer:hover {
    /* scale: 10; */
    z-index: 12 !important;
  }

  .framesImgViewer:focus,
  .framesImgViewer:active {
    z-index: 50 !important;
    scale: 10;
  }

  .markerContainer {
    background: red;
    height: 24px;
    position: absolute;
    z-index: 2;
    cursor: pointer;
    text-align: center;
    line-height: 25px;
  }

  .selectedmarkerContainer {
    background: red;
    height: 24px;
    position: absolute;
    /* z-index: 3 !important; */
    cursor: pointer;
    text-align: center;
    line-height: 25px;
  }

  .labelFrames {
    background: repeating-linear-gradient(45deg,
        #606dbc,
        #606dbc 10px,
        #465298 10px,
        #465298 20px);
  }


  .unorderListStyle {
    margin-top: 10%;
    list-style: none;
    padding-left: 0px;
    height: 152px;
    overflow-y: auto;
    margin-bottom: 0px;
    margin-top: -6px;
    direction: rtl;

    ::-webkit-scrollbar-button {
      background: #ccc
    }

    ::-webkit-scrollbar {
      width: 0px !important;
      height: 0px !important
    }

    ::-webkit-scrollbar-track-piece {
      background: #eee
    }

    ::-webkit-scrollbar-thumb {
      background: #888
    }
  }

  @media screen and (max-width: 1980px) {
    .listStyleForLabels {
      margin-bottom: 16%;
      display: flex;
      direction: ltr;
      padding-left: 10px;
    }
  }

  @media screen and (max-width: 1466px) {
    .listStyleForLabels {
      margin-bottom: 27px;
      display: flex;
      direction: ltr;
      padding-left: 10px;
    }
  }


  .playback_for_video {
    width: 100%;
    position: relative;
    margin-top: 0.21rem;
    height: 10px;
    background: #2f3b44;
    margin-bottom: 0.2rem;
    border-radius: 1em;
  }

  .playback {
    width: 100%;
    position: relative;
    margin-top: 1rem;
    /* margin-left: 24px; */
    margin-right: 0px;
    height: 5px;
    background: #2f3b44;
    margin-bottom: 30px;
    border-radius: 1em;
  }

  .playbackVideo {
    margin-left: 0px;
    margin-right: 0px;
    margin-top: -5px;
    margin-bottom: 0.2rem;
    height: 5px;
  }

  .playback .seekable {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 5px;
    background: rgb(240, 240, 240);
    cursor: pointer;
  }

  .playback .grabber {
    z-index: 4 !important;
    font-size: 28px;
    height: 26px;
    position: absolute;
    bottom: -9.9px;
    width: 8px;
    border-radius: 0px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.4);
    cursor: pointer;
    transition: transform 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 4px;
  }

  .playback .grabber.start {
    text-indent: -3px;
  }

  .playback .grabber.frammerstart {
    text-indent: -3px;
    height: 26px;
    top: -8px;
  }

  .playback .grabber.end {
    text-indent: 3px;
    margin-left: -8px;
  }

  .playback .currentSelectedTab.end {
    text-indent: 3px;
    margin-left: -8px;
  }

  .playback .grabber.framerend {
    text-indent: 3px;
    height: 26px;
    top: -8px;
    margin-left: -8px;
  }

  .playback .grabber:hover {
    transform: scaleY(1.1);
  }


  .currentSelectedTab {
    z-index: 100 !important;
    font-size: 28px;
    height: 26px;
    position: absolute;
    bottom: -10px;
    width: 8px;
    border-radius: 0px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.4);
    cursor: pointer;
    transition: transform 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 4px;
  }

  .inputOpenedTab {
    z-index: 101 !important;
    font-size: 28px;
    height: 26px;
    position: absolute;
    bottom: -10px;
    width: 8px;
    border-radius: 0px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.4);
    cursor: pointer;
    transition: transform 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 4px;
  }

  .playback .currentSelectedTab.start {
    text-indent: -4px;
    bottom: -8px;
  }

  .playback .currentSelectedTab.end {
    text-indent: 3px;
    bottom: -8px;
    margin-left: -8px;
  }

  .playback .currentSelectedTab:hover {
    transform: scaleY(1.1);
  }

  .grabber:active {
    scale: 1.3;
    cursor: -webkit-grabbing;
  }

  .playback .completegrabber {
    font-size: 28px;
    height: 22px;
    position: absolute;
    margin-top: -5.5px;
    border-radius: 0px;
    cursor: pointer;
    transition: transform 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .playback .completegrabber:hover {
    transform: scaleY(1.1);
  }

  .playback .progress {
    background: #0072cf;
    position: absolute;
    overflow: visible;
    left: 0;
    height: 5px !important;
    top: 0;
    bottom: 0;
    cursor: pointer;
    pointer-events: none;
  }

  .timingcontainer {
    display: flex;
    text-align: right;
    margin-top: -9px;
    font-size: 11px;
    font-weight: 900;
    font-family: none;
  }

  .frameTimingContainer {
    justify-content: space-between;
  }

  .seekable_time {
    background: black;
    position: absolute;
    height: 2px;
    top: 22px;
    bottom: 0;
    left: 0;
    right: 0;
    cursor: pointer;
  }

  .playback_timer {
    width: 100%;
    position: relative;
    margin-top: 1rem;
    /* margin-left: 24px; */
    margin-right: 0px;
    margin-bottom: 1rem;
    cursor: pointer;
    border-radius: 1em;
  }

  .controls {
    display: flex;
    justify-content: space-between;
    text-align: center;
    margin-top: -43px;
    width: 108%;
    margin-left: -4%;
  }

  .controls .player-controls button {
    width: 34px;
    margin: 0 0.125rem;
  }

  .labelbuttons {
    cursor: pointer;
    border: 0.5px solid gray;
    border-radius: 9%;
    height: 28px;
    margin-left: 8px;
  }

  .controls .player-controls .play-control {
    background: #2f3b44;
    border: 0;
    color: #a5b0b5;
    padding: 0.5rem;
    border-radius: 4px;
    cursor: pointer;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  @media screen and (max-width: 1980px) {
    .roi-info-container {
      margin-top: -43px;
      position: absolute;
      width: 150px;
      margin-left: -95px;
    }

    .roi-selector-delete-button {
      position: absolute;
      z-index: 233;
      background: #e74c3c;
      border: 0;
      color: #ffffff;
      padding: 0.5rem;
      border-radius: 4px;
      cursor: pointer;
      font-weight: bold;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      width: 180px !important;
      margin-left: -192px !important;
    }

    .roi-selector-delete-button:hover {
      background: #c0392b;
    }

    .roi-info-button {
      position: absolute;
      z-index: 233;
      background: #2f3b44;
      border: 0;
      color: #ffffff;
      padding: 0.5rem;
      border-radius: 4px;
      cursor: pointer;
      font-weight: bold;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      margin-left: 32px !important;
      width: 75px !important;
    }

    .roi-info-button:hover {
      background: #445562;
    }
  }

  @media screen and (max-width: 1466px) {
    .roi-info-container {
      margin-top: -43px;
      position: absolute;
      width: 150px;
      margin-left: -100px;
    }

    .roi-selector-delete-button {
      position: absolute;
      z-index: 233;
      background: #e74c3c;
      border: 0;
      color: #ffffff;
      padding: 0.5rem;
      border-radius: 4px;
      cursor: pointer;
      font-weight: bold;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      width: 117px !important;
      margin-left: -92px !important;
    }

    .roi-selector-delete-button:hover {
      background: #c0392b;
    }

    .roi-info-button {
      position: absolute;
      z-index: 233;
      background: #2f3b44;
      border: 0;
      color: #ffffff;
      padding: 0.5rem;
      border-radius: 4px;
      cursor: pointer;
      font-weight: bold;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      margin-left: 32px !important;
      width: 51px !important;
    }

    .roi-info-button:hover {
      background: #445562;
    }
  }



  .videoPlayPuase {
    position: absolute;
    z-index: 233;
  }

  .roi-selector-cancel-button {
    position: absolute;
    z-index: 233;
    background: #e74c3c;
    border: 0;
    color: #ffffff;
    padding: 0.5rem;
    border-radius: 4px;
    cursor: pointer;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  .roi-selector-cancel-button:hover {
    background: #c0392b;
  }

  .controls .player-controls .play-control:hover {
    background: #445562;
  }

  .controls .player-controls .play-control:active {
    color: #ffffff;
  }

  .controls .player-controls .seek-start {
    background: #2f3b44;
    border: 0;
    color: #a5b0b5;
    padding: 0.5rem;
    border-radius: 4px;
    cursor: pointer;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  .controls .player-controls .seek-start:hover {
    background: #445562;
  }

  .controls .player-controls .seek-start:active {
    color: #ffffff;
  }

  .controls .player-controls .seek-end {
    background: #2f3b44;
    border: 0;
    color: #a5b0b5;
    padding: 0.5rem;
    border-radius: 4px;
    cursor: pointer;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  .controls .player-controls .seek-end:hover {
    background: #445562;
  }

  .controls .player-controls .seek-end:active {
    color: #ffffff;
  }

  .controls .settings-control {
    background: #2f3b44;
    border: 0;
    color: #a5b0b5;
    padding: 0.5rem;
    border-radius: 4px;
    cursor: pointer;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  .controls .meta-downloader {
    background: #2f3b44;
    border: 0;
    color: #a5b0b5;
    padding: 0.5rem;
    border-radius: 4px;
    cursor: pointer;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    position: absolute;
    margin-top: -245px !important;
  }

  .analytic-chart-data {
    background: #2f3b44;
    border: 0;
    color: #a5b0b5;
    padding: 0.5rem;
    border-radius: 4px;
    cursor: pointer;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    position: absolute;
    margin-top: -200px !important;
  }

  .controls .settings-control:active {
    color: #ffffff;
  }

  .controls .settings-control:hover {
    background: #445562;
  }

  .controls .trim-control {
    background: #0072cf;
    border: 0;
    color: #fff;
    padding: 0.5rem;
    border-radius: 4px;
    cursor: pointer;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 0.1em;
  }

  .controls .trim-control:hover {
    background: #038eff;
  }

  .margined {
    margin: 0em 0.3em;
  }

  .warning {
    padding: 0.8em;
    color: #da7f00;
    background-color: #ffecd1;
    border-radius: 0.3em;
    border: 0.1em solid #f0ad4e;
    margin: 1em;
    justify-content: center;
    text-align: center;
  }

  .thumbnail {
    width: 20%;
    height: auto;
    justify-content: center;
    align-items: center;
    border: 0.2em solid black;
    border-radius: 0.3em;
  }

  .marginVertical {
    margin: 1.5em 0em;
  }

  .videoframeController {
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    margin-left: 30px;
    width: 40%;
    /* padding-left: 24px; */
  }

  .progress_time {
    position: absolute;
    font-size: 12px;
    margin-top: -14px;
    columns: black;
    background: white !important;
    /* margin-left: 30%; */
  }

  .progress_time1 {
    position: absolute;
    font-size: 12px;
    margin-top: -20px;
    columns: black;
    background: white !important;
    /* margin-left: 30%; */
  }

  .progress_time1 .timeFrame {
    font-size: 18px;
    font-weight: bold;
  }

  .progress_time1 .timeFrameline {
    margin: 0px;
    font-size: 6px;
    margin-top: 12px;
    font-family: none;
    font-weight: 900;
  }

  .progress_time .timeFrameline {
    margin: 0px;
    font-size: 6px;
    margin-top: 12px;
    font-family: none;
    font-weight: 900;
  }

  .progress_time .timeFrame {
    margin-top: -1px;
    margin-bottom: 0px;
    font-size: 12px;
  }

  .playbackControllContainer {
    margin-bottom: 0px;
    margin-top: 15px;
    height: 5px;
  }

  .labelplaypauseControler {
    background: transparent;
    width: 26px;
    padding-left: 6px;
    border: none;
    cursor: pointer;
  }

  /* toggle button */
  .switch {
    width: 60px;
    height: 34px;
    outline: none;
    scale: 0.7;
    margin-top: 8px;
  }

  .switch input {
    position: absolute;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: 0.4s;
    border-radius: 34px;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    transition: 0.4s;
    border-radius: 50%;
  }

  input:checked + .slider {
    background-color: #2196f3;
  }

  input:focus + .slider {
    box-shadow: 0 0 1px #2196f3;
  }

  input:checked + .slider:before {
    transform: translateX(26px);
  }

  /* .containerForFrameEnable{
    width: 300px;
    height: 100px;
  } */

  .frameTimeLines {
    position: absolute;
    margin-top: -13px;
    font-size: 9px;
    margin-left: 22px;
    z-index: 100;
  }

  .frameTimeLinesright {
    position: absolute;
    margin-top: -13px;
    font-size: 9px;
    z-index: 100;
    margin-left: -30px;
  }

  .hmsframeInput {
    position: absolute;
    width: 85px;
    height: 34px;
    font-size: 20px;
    margin-top: 3px;
    z-index: 6 !important;
  }

  .hmsframeInputRight {
    margin-left: -80px;
  }

  .hmsframeInputLeft {
    margin-left: 80px;
  }

  .sublabelSelectorButton {
    margin-top: 11px;
    display: block;
    width: 100%;
    border-radius: 5px;
    margin-bottom: 20px;
  }

  .labelSelector {
    width: 100%;
    height: 36px;
    cursor: pointer;
    margin-top: 8px;
    margin-bottom: -6px;
    border-radius: 4px;
    border: 1px solid #ced4da;
  }

  table {
    width: 350px;
    height: 100px;
    border-collapse: collapse;
    /*Entfernt die Standardabstände zwischen den Tabellenzellen */
  }

  thead {
    background: rgb(153, 208, 240);
  }

  th,
  td {
    width: 70px;
    text-align: left;
    border: 1px solid #d6d6d6;
  }

  .tooltip {
    position: relative;
    display: inline-block;
    border-bottom: 1px dotted black;
  }

  .tooltip .tooltiptext {
    visibility: hidden;
    width: 120px;
    background-color: black;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;

    /* Position the tooltip */
    position: absolute;
    z-index: 1;
    bottom: 100%;
    left: 50%;
    margin-left: -60px;
  }

  .tooltip:hover .tooltiptext {
    visibility: visible;
  }


  /* popup modal */
  .modal {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 35%;
    background-color: white;
    border: none;

  }

  .modalContenContainer {
    padding: 16px;
    padding-bottom: 11%;
  }

  .modalHeadContainer {
    display: flex;
    justify-content: space-between;
  }

  .modalCloseButton {
    height: 23px;
    background: none;
    border: none;
    font-size: 19px;
    cursor: pointer;
  }

  .modal p {
    font-weight: 900;
  }

  .modalButtonsContainer {
    width: 100%;
    display: flex;
    justify-content: stretch;
  }

  .modalSubmitButton {
    width: 100%;
    padding: 3%;
    cursor: pointer;
  }

  .cancelButton {
    background-color: gray;
    border: 0.5px solid gray;
  }

  .submitButton {
    background-color: #038eff;
    border: 0.5px solid #038eff;
    color: white;
  }

  .submitButton:hover {
    background-color: #2980b9;
    color: white;
  }

  .newLabelInputs {
    display: flex;
    flex-direction: column;
    text-align: left;
  }


  /* Alert Box */

  .alertImg {
    margin-left: 3%;
  }

  #toast {
    visibility: hidden;
    border: 1px solid;
    border-left: 10px solid;
    height: 67px;
    margin-left: 75%;
    width: 20%;
    background-color: #ffffff;
    color: #000000;
    text-align: center;
    border-radius: 2px;
    position: fixed;
    z-index: 1301;
    left: 0;
    right: 0;
    bottom: 30px;
    font-size: 17px;
  }

  .toastCloser {
    margin-top: -6%;
    background: transparent;
    border: none;
  }

  #toast.show {
    visibility: visible;
    animation: fadein 0.5s, fadeout 0.5s 1.5s;
  }

  @keyframes fadein {
    from {
      left: 30%;
      opacity: 0;
    }

    to {
      left: 0%;
      opacity: 1;
    }
  }

  @keyframes fadeout {
    from {
      left: 0%;
      opacity: 1;
    }

    to {
      left: 30%;
      opacity: 0;
    }
  }

  .messageheadContainer {
    display: flex;
    width: 100%;
    justify-content: space-between;
    padding: 0%;
    padding-top: 1%;
    padding-left: 5%;
    padding-bottom: 0%;
  }

  .toast-check {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 35px;
    width: 35px;
    background-color: #40f467;
    border-radius: 50%;
    color: #fff;
    font-size: 20px;
  }

  .message {
    display: flex;
    flex-direction: column;
    margin: 1px 20px 0px 7px;
    text-align: left;
    padding-left: 3%;
  }

  .message-text {
    font-size: 20px;
    font-weight: 600;
  }

  .text-1 {
    color: #333;
    margin-top: 2%;
  }

  .text-2 {
    color: #666;
    font-weight: 400;
    font-size: 16px;
  }

  .toast-close {
    position: absolute;
    top: 10px;
    right: 15px;
    padding: 5px;
    cursor: pointer;
    opacity: 0.7;
  }

  .toast-close:hover {
    opacity: 1;
  }

  .annotateSubmitButton {
    margin-top: -42px;
    position: absolute;
    width: 140px;
    height: 40px;
    background: #16a436;
    border: 1px #def4e0;
    color: white;
    border-radius: 3px;
    z-index: 202;
  }

  .annotateSubmitButton:hover,
  .annotateSubmitButton:active {
    background: #0b7323;
    color: white;
  }

  .annotatesubmitcontainer {
    margin-top: 0.5%;
    position: absolute;
  }
}

.ContainerForTheAnnoatatorModal {
  .MuiBackdrop-root {
    background: none;
  }

  .MuiBox-root {
    width: 50%;
  }

  .alertMessage {
    padding-left: 30px;
    padding-right: 30px;
  }

  .alertMessage-for-shortcuts {
    margin-top: 30vh;
    padding-left: 30px;
    padding-right: 30px;
  }

  .confirmationModalbuttonContainer {
    width: 100%;
    display: flex;
  }

  .confirmationButtons {
    width: 50%;
    height: 47px;
    border: none;
  }

  .confirmationCancel {
    background: #ffd6d6;
    border: #FFE5E5;
    color: #ff6b6b;
  }

  .confirmationCancel:hover,
  .confirmationCancel:active {
    background: #fc5858;
    color: white;
  }

  .confirmationYes {
    background: #0b7323;
    border: 1px #def4e0;
    color: #16a436;
  }

  .confirmationYes:hover,
  .confirmationYes:active {
    background: #16a436;
    color: white;
  }

  .containerForRoiModal {
    padding: 0px 22px;

    .heading {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
    }

    .editButton {
      cursor: pointer;
      background-color: transparent;
      color: white;
      border: none;
      padding: 0px;
      font-size: 23px;
      width: 29px;
    }

    .textareaContainer {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    .textarea {
      width: 100%;
      padding: 10px;
      border-radius: 4px;
      border: 1px solid #ccc;
      height: 67px;
    }

    .copyButton {
      cursor: pointer;
      background-color: #28a745;
      color: white;
      border: none;
      border-radius: 4px;
      padding: 5px 10px;
      align-self: flex-end;
    }

    .buttonContainer {
      display: flex;
      justify-content: space-between;
    }

    .saveButton {
      cursor: pointer;
      background-color: #007bff;
      color: white;
      border: none;
      border-radius: 4px;
      padding: 5px 10px;
    }

    .closeButton {
      cursor: pointer;
      background-color: #dc3545;
      color: white;
      border: none;
      border-radius: 4px;
      padding: 5px 10px;
    }

    .row {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
    }

    .fieldBox {
      flex: 1 1;
      border: 1px solid #ccc;
      padding: 10px;
      border-radius: 4px;
      margin-right: 5px;
      background-color: #fff;
      text-align: center;
    }

  }

  .frame_export_inp_container {
    margin-top: 20px;
  }

  .frame_export_header {
    text-align: center;
  }
  .labels-key-information{
    font-size: 14px;
    color: #333;
    margin-bottom: 10px;
  }

  .labels-info-container {
    max-height: 70vh;
    overflow-y: scroll;
  }

  .sublabel-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
    overflow: hidden;

    tr,
    td,
    th {
      border: 1px solid #ddd;
      padding: 8px;
    }

    .left-cells {
      width: 30%;
      text-align: left;
    }

    .right-cells {
      width: 70%;
      text-align: left;
    }

    .access-key-controll {
      width: 25px;
      height: 25px;
    }
    .access-key-input{
      width: 30%;
    }
  }

  .modal-dropdown {
    width: 90%;
    margin-left: 5%;
    padding: 7px;
    margin-bottom: 4%;
    border-radius: 5px;
    background: white;
  }

  .dropdown-container {
    width: 100%;
    margin: 5%;

    .dropdown-input {
      width: 90%;
    }

    .dropdown-option {
      overflow: hidden;
    }

    .dropdown-option:hover {
      background-color: #f0f0f0;
    }
  }

  .drop-down-menu {
    position: absolute;
    width: 90%;
    max-height: 200px;
    overflow: auto;
  }

  .label-selector-dropdown {
    width: 90%;
    margin: 5%;
    /* border-radius: 5px; */
  }

  .modal-box {
    height: auto;
  }

  .close-icon {
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
    font-size: 20px;
    color: #333;
  }

  .frame_download_loader {
    width: 100%;
    text-align: center;
    margin-top: 50px;
  }

  .frame_interval_input {
    width: 100%;
    margin: 1%;
    padding: 5px;
    border: 1px solid;
    border-radius: 3px;
  }

  .frame_download_submit_button {
    background: #d5d8d8;
    border: #d5d8d8;
    min-width: 180px;
    width: 100%;
    margin: 1%;
    padding: 5px;
    color: #343636;
    border-radius: 3px;
    height: 39px;
  }
}

.ContainerForChartDataModal {
  .MuiBackdrop-root {
    background: none;
  }

  .MuiBox-root {
    width: 50%;
  }

  .analyticTableHeader {
    display: flex;
    justify-content: space-between;

  }

  /* Basic table styling */
  table {
    width: 100%;
    border-collapse: collapse;
    margin: 20px 0;
    font-size: 1em;
    font-family: Arial, sans-serif;
    text-align: left;
  }

  th,
  td {
    padding: 12px 15px;
    border: 1px solid #ddd;
  }

  /* Table header styling */
  th {
    background-color: #6bd0ff;
    color: white;
  }

  /* Hover effect on rows */
  tr:hover {
    background-color: #f1f1f1;
    cursor: pointer;
  }

  /* Export button styling */
  button {
    margin: 10px 0;
    padding: 8px 12px;
    background-color: #d6f5ff;
    color: #6bd0ff;
    border: none;
    cursor: pointer;
    font-size: 1em;
  }

  button:hover {
    background-color: #6bd0ff;
    color: white;
  }

}

.autoCompleteComponent {
  margin-top: 2%;
}

.MuiOutlinedInput-root {
  padding: 5px 9px !important;
}

::-webkit-scrollbar {
  width: 3px;
  height: 3px
}

::-webkit-scrollbar-button {
  background: #ccc
}

::-webkit-scrollbar-track-piece {
  background: #eee
}

::-webkit-scrollbar-thumb {
  background: #888
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/editor.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB;;;;;;;;;;;;;;;;;;;;;;;KAuBG;EACH;;;;KAIG;;EAEH;IACE,eAAe;IACf,SAAS;IACT,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,aAAa;EACf;;EAEA,wBAAwB;EACxB;IACE,UAAU;IACV,kBAAkB;IAClB,2BAA2B;IAC3B,eAAe;IACf,yBAAyB;IACzB,WAAW;IAEX,mBAAmB;IAEnB,4BAA4B;IAE5B,2BAA2B;IAC3B,iBAAiB;IACjB,iFAAiF;EACnF;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,cAAc;IACd,eAAe;IACf,8BAA8B;IAC9B,cAAc;IACd,2BAA2B;IAC3B,eAAe;IACf,yBAAyB;IACzB,WAAW;IAEX,mBAAmB;IAEnB,4BAA4B;IAE5B,2BAA2B;IAC3B,iBAAiB;IACjB,iFAAiF;EACnF;;EAEA;IACE,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,8BAA8B;IAC9B;uBACmB;EACrB;;;EAGA;IACE;MACE,UAAU;MACV,WAAW;MACX,cAAc;MACd,YAAY;MACZ,uBAAuB;MACvB,kBAAkB;IACpB;EACF;;EAEA;IACE;MACE,UAAU;MACV,WAAW;MACX,eAAe;MACf,YAAY;MACZ,uBAAuB;IACzB;EACF;;;EAGA;IACE;MACE,UAAU;MACV,WAAW;MACX,cAAc;MACd,YAAY;MACZ,uBAAuB;MACvB,kBAAkB;MAClB,aAAa;MACb,sBAAsB;MACtB,SAAS;MACT,aAAa;IACf;EACF;;EAEA;IACE;MACE,WAAW;MACX,yBAAyB;MACzB,WAAW;MACX,YAAY;MACZ,aAAa;MACb,sBAAsB;MACtB,SAAS;MACT,YAAY;MACZ,gCAAgC;MAChC,eAAe;MACf,uBAAuB;IACzB;EACF;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,WAAW;IACX,WAAW;IACX,aAAa;IACb,yCAAyC;IACzC,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,eAAe;IACf,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,uDAAuD;EACzD;;EAEA;;IAEE,yBAAyB;IACzB,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE;MACE,gBAAgB;MAChB,iCAAiC;IACnC;EACF;;;EAGA;IACE,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;;EAGA;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE;MACE,gBAAgB;MAChB,kBAAkB;MAClB,YAAY;MACZ,yBAAyB;MACzB,2BAA2B;MAC3B,YAAY;IACd;;IAEA;MACE,yBAAyB;MACzB,YAAY;IACd;EACF;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE;MACE,kBAAkB;MAClB,YAAY;MACZ,aAAa;MACb,kBAAkB;IACpB;;IAEA;MACE,eAAe;MACf,YAAY;MACZ,aAAa;MACb,kBAAkB;MAClB,YAAY;IACd;;EAEF;;;;EAIA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,2BAA2B;IAC3B,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IAEE,uBAAuB;IACvB,kBAAkB;IAClB;EACF;;EAEA;IACE;MACE,kBAAkB;MAClB,gBAAgB;MAChB,gBAAgB;MAChB,WAAW;MACX,eAAe;MACf,mBAAmB;MACnB,kBAAkB;MAClB,YAAY;MACZ,uBAAuB;IACzB;;IAEA;MAEE,uBAAuB;MACvB,kBAAkB;MAClB;IACF;EACF;;EAEA;IACE;MACE,kBAAkB;MAClB,gBAAgB;MAChB,gBAAgB;MAChB,WAAW;MACX,eAAe;MACf,mBAAmB;MACnB,kBAAkB;MAClB,YAAY;MACZ,uBAAuB;IACzB;;IAEA;MAEE,uBAAuB;MACvB,kBAAkB;MAClB;IACF;EACF;;;;;EAKA;IACE;MACE,kBAAkB;MAClB,iBAAiB;MACjB,oBAAoB;MACpB,YAAY;MACZ,aAAa;MACb,YAAY;IACd;EACF;;EAEA;IACE;MACE,kBAAkB;MAClB,kBAAkB;MAClB,iBAAiB;MACjB,YAAY;MACZ,aAAa;MACb,YAAY;IACd;EACF;;;EAGA;IACE,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;;IAEE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;;IAEE,mBAAmB;IACnB,YAAY;EACd;;;;EAIA;IACE,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;;IAEE,mBAAmB;IACnB,YAAY;EACd;;;;EAIA;IACE,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE;MACE,kBAAkB;MAClB,uBAAuB;IACzB;;IAEA;MACE,kBAAkB;MAClB,iBAAiB;MACjB,gBAAgB;MAChB,YAAY;MACZ,eAAe;MACf,mBAAmB;MACnB,kBAAkB;MAClB,yBAAyB;MACzB,eAAe;MACf,YAAY;IACd;;EAEF;;EAEA;IACE;MACE,kBAAkB;MAClB,uBAAuB;IACzB;;IAEA;MACE,kBAAkB;MAClB,eAAe;MACf,gBAAgB;MAChB,YAAY;MACZ,eAAe;MACf,mBAAmB;MACnB,kBAAkB;MAClB,yBAAyB;MACzB,eAAe;MACf,YAAY;IACd;EACF;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,mBAAmB;EACrB;;EAEA;;GAEC;EACD;IACE,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE;EACF;;EAEA;IACE;MACE;IACF;EACF;;EAEA;IACE;MACE;IACF;EACF;;EAEA;IACE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,gCAAgC;EAClC;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;;;OAGK;;EAEL;;OAEK;EACL;IACE,wBAAwB;IACxB,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,6BAA6B;IAC7B,8BAA8B;IAE9B,8BAA8B;IAC9B,2BAA2B;IAC3B,6BAA6B;IAC7B,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;;IAEvB;MACE,UAAU;MACV;IACF;;IAEA;MACE;IACF;;IAEA;MACE;IACF;;IAEA;MACE;IACF;EACF;;EAEA;IACE,UAAU;IACV;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE;EACF;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;IACf,sBAAsB;EACxB;;EAEA;;IAEE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,eAAe;IACf,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE;;;;qBAIiB;EACnB;;;EAGA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;;IAEd;MACE;IACF;;IAEA;MACE,qBAAqB;MACrB;IACF;;IAEA;MACE;IACF;;IAEA;MACE;IACF;EACF;;EAEA;IACE;MACE,kBAAkB;MAClB,aAAa;MACb,cAAc;MACd,kBAAkB;IACpB;EACF;;EAEA;IACE;MACE,mBAAmB;MACnB,aAAa;MACb,cAAc;MACd,kBAAkB;IACpB;EACF;;;EAGA;IACE,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,8BAA8B;IAC9B,eAAe;EACjB;;EAEA;IACE,qBAAqB;IACrB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,wCAAwC;IACxC,eAAe;IACf,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,SAAS;IACT,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;;EAGA;IACE,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,wCAAwC;IACxC,eAAe;IACf,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,kBAAkB;IAClB,wCAAwC;IACxC,eAAe;IACf,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,UAAU;IAEV,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,OAAO;IACP,sBAAsB;IACtB,MAAM;IACN,SAAS;IACT,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,SAAS;IACT,OAAO;IACP,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,wBAAwB;IACxB,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,SAAS;IACT,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE;MACE,iBAAiB;MACjB,kBAAkB;MAClB,YAAY;MACZ,kBAAkB;IACpB;;IAEA;MACE,kBAAkB;MAClB,YAAY;MACZ,mBAAmB;MACnB,SAAS;MACT,cAAc;MACd,eAAe;MACf,kBAAkB;MAClB,eAAe;MACf,iBAAiB;MACjB,yBAAyB;MACzB,sBAAsB;MACtB,uBAAuB;MACvB,8BAA8B;IAChC;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,kBAAkB;MAClB,YAAY;MACZ,mBAAmB;MACnB,SAAS;MACT,cAAc;MACd,eAAe;MACf,kBAAkB;MAClB,eAAe;MACf,iBAAiB;MACjB,yBAAyB;MACzB,sBAAsB;MACtB,4BAA4B;MAC5B,sBAAsB;IACxB;;IAEA;MACE,mBAAmB;IACrB;EACF;;EAEA;IACE;MACE,iBAAiB;MACjB,kBAAkB;MAClB,YAAY;MACZ,mBAAmB;IACrB;;IAEA;MACE,kBAAkB;MAClB,YAAY;MACZ,mBAAmB;MACnB,SAAS;MACT,cAAc;MACd,eAAe;MACf,kBAAkB;MAClB,eAAe;MACf,iBAAiB;MACjB,yBAAyB;MACzB,sBAAsB;MACtB,uBAAuB;MACvB,6BAA6B;IAC/B;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,kBAAkB;MAClB,YAAY;MACZ,mBAAmB;MACnB,SAAS;MACT,cAAc;MACd,eAAe;MACf,kBAAkB;MAClB,eAAe;MACf,iBAAiB;MACjB,yBAAyB;MACzB,sBAAsB;MACtB,4BAA4B;MAC5B,sBAAsB;IACxB;;IAEA;MACE,mBAAmB;IACrB;EACF;;;;EAIA;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,SAAS;IACT,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,SAAS;IACT,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,SAAS;IACT,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,SAAS;IACT,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,SAAS;IACT,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;IACnB,SAAS;IACT,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,cAAc;IACd,yBAAyB;IACzB,oBAAoB;IACpB,2BAA2B;IAC3B,WAAW;IACX,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;IACV,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,4BAA4B;IAC5B,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,4BAA4B;IAC5B,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,eAAe;EACjB;;EAEA,kBAAkB;EAClB;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,sBAAsB;IAEtB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,SAAS;IACT,WAAW;IACX,uBAAuB;IAEvB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IAGE,2BAA2B;EAC7B;;EAEA;;;KAGG;;EAEH;IACE,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,YAAY;IACZ,aAAa;IAEb,yBAAyB;IACzB,6DAA6D;EAC/D;;EAEA;IACE,8BAA8B;EAChC;;EAEA;;IAEE,WAAW;IACX,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,qBAAqB;IACrB,+BAA+B;EACjC;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;;IAEd,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;;EAGA,gBAAgB;EAChB;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,UAAU;IACV,uBAAuB;IACvB,YAAY;;EAEd;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;;;EAGA,cAAc;;EAEd;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,mBAAmB;IAEnB,yCAAyC;EAC3C;;EAcA;IACE;MACE,SAAS;MACT,UAAU;IACZ;;IAEA;MACE,QAAQ;MACR,UAAU;IACZ;EACF;;EAcA;IACE;MACE,QAAQ;MACR,UAAU;IACZ;;IAEA;MACE,SAAS;MACT,UAAU;IACZ;EACF;;EAEA;IACE,aAAa;IACb,WAAW;IACX,8BAA8B;IAC9B,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,wBAAwB;IACxB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,eAAe;IACf,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,YAAY;EACd;;EAEA;;IAEE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,cAAc;EAChB;;EAEA;;IAEE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;;IAEE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,iBAAiB;;IAEjB;MACE,aAAa;MACb,8BAA8B;MAC9B,mBAAmB;MACnB,mBAAmB;IACrB;;IAEA;MACE,eAAe;MACf,6BAA6B;MAC7B,YAAY;MACZ,YAAY;MACZ,YAAY;MACZ,eAAe;MACf,WAAW;IACb;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,SAAS;IACX;;IAEA;MACE,WAAW;MACX,aAAa;MACb,kBAAkB;MAClB,sBAAsB;MACtB,YAAY;IACd;;IAEA;MACE,eAAe;MACf,yBAAyB;MACzB,YAAY;MACZ,YAAY;MACZ,kBAAkB;MAClB,iBAAiB;MACjB,oBAAoB;IACtB;;IAEA;MACE,aAAa;MACb,8BAA8B;IAChC;;IAEA;MACE,eAAe;MACf,yBAAyB;MACzB,YAAY;MACZ,YAAY;MACZ,kBAAkB;MAClB,iBAAiB;IACnB;;IAEA;MACE,eAAe;MACf,yBAAyB;MACzB,YAAY;MACZ,YAAY;MACZ,kBAAkB;MAClB,iBAAiB;IACnB;;IAEA;MACE,aAAa;MACb,8BAA8B;MAC9B,mBAAmB;IACrB;;IAEA;MACE,SAAO;MACP,sBAAsB;MACtB,aAAa;MACb,kBAAkB;MAClB,iBAAiB;MACjB,sBAAsB;MACtB,kBAAkB;IACpB;;EAEF;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;;IAEhB;;;MAGE,sBAAsB;MACtB,YAAY;IACd;;IAEA;MACE,UAAU;MACV,gBAAgB;IAClB;;IAEA;MACE,UAAU;MACV,gBAAgB;IAClB;;IAEA;MACE,WAAW;MACX,YAAY;IACd;IACA;MACE,UAAU;IACZ;EACF;;EAEA;IACE,UAAU;IACV,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,UAAU;;IAEV;MACE,UAAU;IACZ;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,UAAU;IACV,UAAU;IACV,wBAAwB;EAC1B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,eAAe;IACf,eAAe;IACf,WAAW;EACb;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,UAAU;IACV,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,UAAU;IACV,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,YAAY;EACd;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,8BAA8B;;EAEhC;;EAEA,wBAAwB;EACxB;IACE,WAAW;IACX,yBAAyB;IACzB,cAAc;IACd,cAAc;IACd,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA,yBAAyB;EACzB;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA,yBAAyB;EACzB;IACE,yBAAyB;IACzB,eAAe;EACjB;;EAEA,0BAA0B;EAC1B;IACE,cAAc;IACd,iBAAiB;IACjB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;AAEF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF","sourcesContent":["body {\n  overflow-x: hidden;\n}\n\n.overallVideoAnnotatorContainer {\n  font-family: none;\n  /* .toggle{\n    background-color:rgb(185, 185, 185);\n    color: yellow;\n    height: 2em;\n    width: 2em;\n    text-align: center;\n    line-height: 2em;\n    vertical-align: middle;\n    border-radius: 100em;\n    font-size: x-large;\n    z-index: 100;\n    position: fixed;\n    bottom: 1em;\n    right: 1em;\n    cursor: pointer;\n    transition: background-color .2s ease;\n    -webkit-touch-callout: none; \n    -webkit-user-select: none; \n     -khtml-user-select: none; \n       -moz-user-select: none; \n        -ms-user-select: none;\n            user-select: none; \n  \n  } */\n  /* \n  .toggle:hover{\n    transition: background-color .2s ease;\n    background-color:rgb(146, 146, 146);\n  } */\n\n  .initialLoader {\n    position: fixed;\n    left: 49%;\n    top: 50%;\n    width: 100%;\n    height: 100%;\n    z-index: 9999;\n  }\n\n  /* Styling for Editing */\n  .wrapper {\n    width: 80%;\n    margin-left: 12.5%;\n    -webkit-touch-callout: none;\n    /* iOS Safari */\n    -webkit-user-select: none;\n    /* Safari */\n    -khtml-user-select: none;\n    /* Konqueror HTML */\n    -moz-user-select: none;\n    /* Old versions of Firefox */\n    -ms-user-select: none;\n    /* Internet Explorer/Edge */\n    user-select: none;\n    /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */\n  }\n\n  .videoAndLabelWrapper {\n    display: flex;\n    width: 100%;\n  }\n\n  .video-info-div {\n    width: 100%;\n    word-break: break-word;\n  }\n\n  .videoContainer {\n    display: flex;\n    flex-direction: column;\n    width: 95%;\n    border: 1px solid gray;\n  }\n\n  .controller_wrapper {\n    float: left;\n    width: 100%;\n    overflow: auto;\n    margin-left: 1%;\n    height: -webkit-fill-available;\n    margin-top: 1%;\n    -webkit-touch-callout: none;\n    /* iOS Safari */\n    -webkit-user-select: none;\n    /* Safari */\n    -khtml-user-select: none;\n    /* Konqueror HTML */\n    -moz-user-select: none;\n    /* Old versions of Firefox */\n    -ms-user-select: none;\n    /* Internet Explorer/Edge */\n    user-select: none;\n    /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */\n  }\n\n  .label_contrll_wrapper {\n    width: 92%;\n    margin-left: 1%;\n    margin-right: 3%;\n    display: flex;\n    margin-top: 2px;\n    height: -webkit-fill-available;\n    /* height: 239px;\n      overflow: auto; */\n  }\n\n\n  @media screen and (max-width: 1980px) {\n    .labelcontainer {\n      width: 15%;\n      float: left;\n      margin-top: 0%;\n      height: 100%;\n      /* margin-bottom: 5%; */\n      text-align: center;\n    }\n  }\n\n  @media screen and (max-width: 1466px) {\n    .labelcontainer {\n      width: 15%;\n      float: left;\n      margin-top: 30%;\n      height: 100%;\n      /* margin-bottom: 5%; */\n    }\n  }\n\n\n  @media screen and (max-width: 1980px) {\n    .labelcontainer-for-nav-bar {\n      width: 15%;\n      float: left;\n      margin-top: 0%;\n      height: 100%;\n      /* margin-bottom: 5%; */\n      text-align: center;\n      display: flex;\n      flex-direction: column;\n      gap: 12px;\n      padding: 12px;\n    }\n  }\n\n  @media screen and (max-width: 1466px) {\n    .labelcontainer-for-nav-bar {\n      width: 50px;\n      background-color: #d5d8d8;\n      float: left;\n      height: 98vh;\n      display: flex;\n      flex-direction: column;\n      gap: 12px;\n      padding: 4px;\n      border-radius: 0px 10px 10px 0px;\n      margin-top: 1vh;\n      /* margin-bottom: 5%; */\n    }\n  }\n\n  .sidebar-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    background-color: #ffffff;\n    padding: 8px 0;\n    width: 60px;\n    float: left;\n    height: 100vh;\n    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);\n    border-radius: 12px;\n    z-index: 100;\n    position: absolute;\n  }\n\n  .sidebar-icon {\n    background: none;\n    border: none;\n    padding: 3px 17px;\n    margin: 6px 0;\n    font-size: 18px;\n    color: #5a5a5a;\n    cursor: pointer;\n    border-radius: 8px;\n    transition: background-color 0.2s ease, color 0.2s ease;\n  }\n\n  .sidebar-icon:hover,\n  .sidebar-icon:focus {\n    background-color: #eaf3ff;\n    color: #1976d2;\n  }\n\n  .sidebar-icon:disabled {\n    opacity: 0.4;\n    cursor: not-allowed;\n  }\n\n  .sidebar-icon-svg {\n    width: 20px;\n    height: 20px;\n  }\n\n  @media screen and (max-width: 1400px) {\n    .sidebar-bottom-icon {\n      margin-top: auto;\n      /* This pushes it to the bottom */\n    }\n  }\n\n\n  .nav-icon-button {\n    background: none;\n    border: none;\n    font-size: 18px;\n    padding: 10px;\n    cursor: pointer;\n    transition: background 0.2s ease;\n  }\n\n  .nav-icon-button:hover {\n    background-color: #e0e0e0;\n    border-radius: 8px;\n  }\n\n  .roi-dropdown {\n    width: 100%;\n    margin-top: 4px;\n  }\n\n\n  .containeForROISelectorModal {\n    position: absolute;\n    width: 100%;\n    left: 0px;\n    height: 99%;\n    z-index: 201;\n  }\n\n  .roiContainer {\n    position: absolute;\n    margin-top: -10%;\n  }\n\n  .roiContainerSlider {\n    margin-top: -13%;\n    z-index: 212;\n    display: flex;\n    position: absolute;\n    width: 179px;\n  }\n\n  .export_frame_button_div {\n    .export_frame_button {\n      min-width: 180px;\n      border-radius: 3px;\n      height: 39px;\n      background-color: #038eff;\n      border: 0.5px solid #038eff;\n      color: white;\n    }\n\n    .export_frame_button:hover {\n      background-color: #2980b9;\n      color: white;\n    }\n  }\n\n  .export_frame_button_div {\n    margin-top: -16.5%;\n    z-index: 212;\n    display: flex;\n    position: absolute;\n  }\n\n  @media screen and (min-width: 1480px) {\n    .export_frame_button_div {\n      margin-top: -10.5%;\n      z-index: 212;\n      display: flex;\n      position: absolute;\n    }\n\n    .roiContainerSlider {\n      margin-top: -8%;\n      z-index: 212;\n      display: flex;\n      position: absolute;\n      width: 179px;\n    }\n\n  }\n\n\n\n  .roiswitch {\n    width: 60px;\n    height: 34px;\n    outline: none;\n    scale: 0.7;\n    margin-top: -5px;\n  }\n\n  .addROIButton {\n    border: none;\n    padding: 6px;\n    margin-right: 2vh;\n    border-radius: 3px;\n    width: 100%;\n    background-color: #038eff;\n    border: 0.5px solid #038eff;\n    color: white;\n  }\n\n  .addROIButton:hover {\n    background-color: #2980b9;\n    color: white;\n  }\n\n  .roiInfoIcon {\n    margin-top: 11px;\n  }\n\n  .croppedVideoContainer {\n    position: absolute;\n    /* margin-top: -71vh; */\n    position: absolute;\n    z-index: 211\n  }\n\n  @media screen and (max-width: 1980px) {\n    .roiSplitter {\n      position: absolute;\n      margin-top: 13vh;\n      min-width: 257px;\n      height: 0px;\n      cursor: pointer;\n      margin-bottom: -6px;\n      border-radius: 4px;\n      z-index: 202;\n      border: 1px solid black;\n    }\n\n    .croppedVideoContainer {\n      position: absolute;\n      /* margin-top: -71vh; */\n      position: absolute;\n      z-index: 211\n    }\n  }\n\n  @media screen and (max-width: 1466px) {\n    .roiSplitter {\n      position: absolute;\n      margin-top: 13vh;\n      min-width: 185px;\n      height: 0px;\n      cursor: pointer;\n      margin-bottom: -6px;\n      border-radius: 4px;\n      z-index: 202;\n      border: 1px solid black;\n    }\n\n    .croppedVideoContainer {\n      position: absolute;\n      /* margin-top: -71vh; */\n      position: absolute;\n      z-index: 211\n    }\n  }\n\n\n\n\n  @media screen and (max-width: 1980px) {\n    .roiControllButtonsContainer {\n      position: absolute;\n      margin-top: -7.2%;\n      margin-left: -12.55%;\n      z-index: 202;\n      display: flex;\n      width: 278px;\n    }\n  }\n\n  @media screen and (max-width: 1466px) {\n    .roiControllButtonsContainer {\n      position: absolute;\n      margin-top: -10.5%;\n      margin-left: -12%;\n      z-index: 202;\n      display: flex;\n      width: 178px;\n    }\n  }\n\n\n  .roiButtons {\n    margin-top: 11px;\n    display: block;\n    width: 100%;\n    border-radius: 0px;\n    border: 1px;\n    padding: 7px 0px;\n  }\n\n  .deletebutton {\n    background: #e74c3c;\n    border: #e74c3c;\n    color: white;\n    border-radius: 3px;\n    margin-right: -3px;\n    margin-left: 2px;\n  }\n\n  .deletebutton:hover,\n  .deletebutton:active {\n    background: #c0392b;\n    color: white;\n  }\n\n  .previewsubmitButton {\n    background: #3498db;\n    border: #3498db;\n    min-width: 140px;\n    color: white;\n    margin-right: 4px;\n    border-radius: 3px;\n  }\n\n  .previewsubmitButton:hover,\n  .previewsubmitButton:active {\n    background: #2980b9;\n    color: white;\n  }\n\n\n\n  .roiSubmitButton {\n    background: #16a436;\n    color: white;\n    min-width: 140px;\n    margin-right: 4px;\n    border-radius: 3px;\n  }\n\n  .roiSubmitButton:hover,\n  .roiSubmitButton:active {\n    background: #0b7323;\n    color: white;\n  }\n\n\n\n  .seperatorLine {\n    border: 1px solid #0072cf;\n    margin-top: 25px;\n  }\n\n  @media screen and (max-width: 1980px) {\n    .seperatorLine {\n      position: absolute;\n      z-index: 106 !important;\n    }\n\n    .savedROISelector {\n      position: absolute;\n      margin-top: 8.7vh;\n      min-width: 251px;\n      height: 30px;\n      cursor: pointer;\n      margin-bottom: -6px;\n      border-radius: 4px;\n      border: 1px solid #ced4da;\n      font-size: 14px;\n      z-index: 202;\n    }\n\n  }\n\n  @media screen and (max-width: 1466px) {\n    .seperatorLine {\n      position: absolute;\n      z-index: 106 !important;\n    }\n\n    .savedROISelector {\n      position: absolute;\n      margin-top: 7vh;\n      min-width: 180px;\n      height: 30px;\n      cursor: pointer;\n      margin-bottom: -6px;\n      border-radius: 4px;\n      border: 1px solid #ced4da;\n      font-size: 14px;\n      z-index: 202;\n    }\n  }\n\n  .remaining-time-container {\n    position: absolute;\n    margin-top: 4%;\n  }\n\n  .remaining-time {\n    color: #dc3545;\n  }\n\n  .video-speed-controller {\n    padding: 2px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-weight: bold;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    width: 61px;\n    font-size: 12px;\n    height: 40px;\n    margin-right: -28px;\n  }\n\n  /* .video-speed-controller:-ms-expand {\n    display: none;\n} */\n  .videoAnnotateLabelContainer {\n    margin-top: 4%;\n    overflow-y: auto;\n    height: 100%;\n    scrollbar-width: none;\n  }\n\n  .playbackMarkedItems {\n    margin-top: 35px !important\n  }\n\n  @media screen and (max-width: 1980px) {\n    .playbackMarkedItems {\n      margin-top: 46px !important\n    }\n  }\n\n  @media screen and (max-width: 1466px) {\n    .playbackMarkedItems {\n      margin-top: 35px !important\n    }\n  }\n\n  .onscrollControllContainer {\n    height: 41px;\n    margin-bottom: 0px;\n  }\n\n  .video {\n    width: 100%;\n    cursor: pointer;\n    height: 69vh !important;\n    border-radius: 1em;\n    border-radius: 10px 10px 0px 0px;\n  }\n\n  .videoplayer {\n    cursor: pointer;\n    z-index: 210;\n    position: absolute;\n    margin-top: 1px;\n  }\n\n  .seconsTimelinetopcontroller {\n    margin-top: -5px;\n    font-size: 12px;\n  }\n\n  .seconsTimeline {\n    margin-top: 2px;\n  }\n\n  .output {\n    display: flex;\n    margin-top: 1rem;\n    /* margin-left: 24px; */\n    margin-right: 24px;\n    margin-bottom: 2rem;\n  }\n\n  .seconsTimelineFrames {\n    text-align: left;\n    width: 5px;\n    margin-top: 10px;\n    list-style: none;\n    overflow: visible;\n    cursor: pointer;\n  }\n\n  .seconsTimelineFrames p {\n    width: 5px;\n    margin-bottom: -25px;\n    text-align: center;\n  }\n\n  .seconsTimelineFrames .hmsparagraph {\n    width: 5px;\n    margin-top: 19px;\n    text-align: center;\n  }\n\n  /* .seconsTimelineFrames:hover{\n      background-color: yellow;\n      scale: 2 1;\n    } */\n\n  /* .secondmeasurement{\n  \n    } */\n  .secondmeasurement:hover {\n    background-color: yellow;\n    scale: 1.1;\n  }\n\n  .secondsDisplay {\n    position: relative;\n    z-index: 5 !important;\n  }\n\n  .secondsDisplayonHover {\n    position: absolute;\n    z-index: 5 !important;\n    margin-top: -10px;\n    font-size: 18px;\n  }\n\n  .secondsHoverLast {\n    margin-left: -2rem;\n  }\n\n  .play_back_timer_frame_control {\n    position: absolute !important;\n    margin-top: -1.5rem !important;\n    height: 54px !important;\n    overflow-x: initial !important;\n    overflow-y: auto !important;\n    border-radius: 0px !important;\n    padding-left: 0px;\n    padding-right: 0px;\n    height: 60px !important;\n\n    ::-webkit-scrollbar {\n      width: 3px;\n      height: 3px\n    }\n\n    ::-webkit-scrollbar-button {\n      background: #ccc\n    }\n\n    ::-webkit-scrollbar-track-piece {\n      background: #eee\n    }\n\n    ::-webkit-scrollbar-thumb {\n      background: #888\n    }\n  }\n\n  .play_back_timer_frame_control::-webkit-scrollbar {\n    width: 3px;\n    height: 3px\n  }\n\n  .play_back_timer_frame_control::-webkit-scrollbar-button {\n    background: #ccc\n  }\n\n  .play_back_timer_frame_control::-webkit-scrollbar-track-piece {\n    background: #eee\n  }\n\n  .play_back_timer_frame_control::-webkit-scrollbar-thumb {\n    background: #888\n  }\n\n  ​ .seekableTimeFrame {\n    margin-left: 15px;\n    padding-right: 15px;\n  }\n\n  .frameSelectorTime {\n    display: none;\n  }\n\n  .frameSelectorTime:hover {\n    display: block;\n  }\n\n  .timeDifference {\n    /* margin-left: 24px; */\n  }\n\n  .framesImgViewer {\n    width: 47px;\n    height: 25px;\n  }\n\n  .imgTopCentre {\n    margin: auto;\n  }\n\n  .framesImgViewer:hover {\n    /* scale: 10; */\n    z-index: 12 !important;\n  }\n\n  .framesImgViewer:focus,\n  .framesImgViewer:active {\n    z-index: 50 !important;\n    scale: 10;\n  }\n\n  .markerContainer {\n    background: red;\n    height: 24px;\n    position: absolute;\n    z-index: 2;\n    cursor: pointer;\n    text-align: center;\n    line-height: 25px;\n  }\n\n  .selectedmarkerContainer {\n    background: red;\n    height: 24px;\n    position: absolute;\n    /* z-index: 3 !important; */\n    cursor: pointer;\n    text-align: center;\n    line-height: 25px;\n  }\n\n  .labelFrames {\n    background: repeating-linear-gradient(45deg,\n        #606dbc,\n        #606dbc 10px,\n        #465298 10px,\n        #465298 20px);\n  }\n\n\n  .unorderListStyle {\n    margin-top: 10%;\n    list-style: none;\n    padding-left: 0px;\n    height: 152px;\n    overflow-y: auto;\n    margin-bottom: 0px;\n    margin-top: -6px;\n    direction: rtl;\n\n    ::-webkit-scrollbar-button {\n      background: #ccc\n    }\n\n    ::-webkit-scrollbar {\n      width: 0px !important;\n      height: 0px !important\n    }\n\n    ::-webkit-scrollbar-track-piece {\n      background: #eee\n    }\n\n    ::-webkit-scrollbar-thumb {\n      background: #888\n    }\n  }\n\n  @media screen and (max-width: 1980px) {\n    .listStyleForLabels {\n      margin-bottom: 16%;\n      display: flex;\n      direction: ltr;\n      padding-left: 10px;\n    }\n  }\n\n  @media screen and (max-width: 1466px) {\n    .listStyleForLabels {\n      margin-bottom: 27px;\n      display: flex;\n      direction: ltr;\n      padding-left: 10px;\n    }\n  }\n\n\n  .playback_for_video {\n    width: 100%;\n    position: relative;\n    margin-top: 0.21rem;\n    height: 10px;\n    background: #2f3b44;\n    margin-bottom: 0.2rem;\n    border-radius: 1em;\n  }\n\n  .playback {\n    width: 100%;\n    position: relative;\n    margin-top: 1rem;\n    /* margin-left: 24px; */\n    margin-right: 0px;\n    height: 5px;\n    background: #2f3b44;\n    margin-bottom: 30px;\n    border-radius: 1em;\n  }\n\n  .playbackVideo {\n    margin-left: 0px;\n    margin-right: 0px;\n    margin-top: -5px;\n    margin-bottom: 0.2rem;\n    height: 5px;\n  }\n\n  .playback .seekable {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 5px;\n    background: rgb(240, 240, 240);\n    cursor: pointer;\n  }\n\n  .playback .grabber {\n    z-index: 4 !important;\n    font-size: 28px;\n    height: 26px;\n    position: absolute;\n    bottom: -9.9px;\n    width: 8px;\n    border-radius: 0px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.4);\n    cursor: pointer;\n    transition: transform 0.2s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding-bottom: 4px;\n  }\n\n  .playback .grabber.start {\n    text-indent: -3px;\n  }\n\n  .playback .grabber.frammerstart {\n    text-indent: -3px;\n    height: 26px;\n    top: -8px;\n  }\n\n  .playback .grabber.end {\n    text-indent: 3px;\n    margin-left: -8px;\n  }\n\n  .playback .currentSelectedTab.end {\n    text-indent: 3px;\n    margin-left: -8px;\n  }\n\n  .playback .grabber.framerend {\n    text-indent: 3px;\n    height: 26px;\n    top: -8px;\n    margin-left: -8px;\n  }\n\n  .playback .grabber:hover {\n    transform: scaleY(1.1);\n  }\n\n\n  .currentSelectedTab {\n    z-index: 100 !important;\n    font-size: 28px;\n    height: 26px;\n    position: absolute;\n    bottom: -10px;\n    width: 8px;\n    border-radius: 0px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.4);\n    cursor: pointer;\n    transition: transform 0.2s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding-bottom: 4px;\n  }\n\n  .inputOpenedTab {\n    z-index: 101 !important;\n    font-size: 28px;\n    height: 26px;\n    position: absolute;\n    bottom: -10px;\n    width: 8px;\n    border-radius: 0px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.4);\n    cursor: pointer;\n    transition: transform 0.2s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding-bottom: 4px;\n  }\n\n  .playback .currentSelectedTab.start {\n    text-indent: -4px;\n    bottom: -8px;\n  }\n\n  .playback .currentSelectedTab.end {\n    text-indent: 3px;\n    bottom: -8px;\n    margin-left: -8px;\n  }\n\n  .playback .currentSelectedTab:hover {\n    transform: scaleY(1.1);\n  }\n\n  .grabber:active {\n    scale: 1.3;\n    cursor: -moz-grabbing;\n    cursor: -webkit-grabbing;\n  }\n\n  .playback .completegrabber {\n    font-size: 28px;\n    height: 22px;\n    position: absolute;\n    margin-top: -5.5px;\n    border-radius: 0px;\n    cursor: pointer;\n    transition: transform 0.2s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .playback .completegrabber:hover {\n    transform: scaleY(1.1);\n  }\n\n  .playback .progress {\n    background: #0072cf;\n    position: absolute;\n    overflow: visible;\n    left: 0;\n    height: 5px !important;\n    top: 0;\n    bottom: 0;\n    cursor: pointer;\n    pointer-events: none;\n  }\n\n  .timingcontainer {\n    display: flex;\n    text-align: right;\n    margin-top: -9px;\n    font-size: 11px;\n    font-weight: 900;\n    font-family: none;\n  }\n\n  .frameTimingContainer {\n    justify-content: space-between;\n  }\n\n  .seekable_time {\n    background: black;\n    position: absolute;\n    height: 2px;\n    top: 22px;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    cursor: pointer;\n  }\n\n  .playback_timer {\n    width: 100%;\n    position: relative;\n    margin-top: 1rem;\n    /* margin-left: 24px; */\n    margin-right: 0px;\n    margin-bottom: 1rem;\n    cursor: pointer;\n    border-radius: 1em;\n  }\n\n  .controls {\n    display: flex;\n    justify-content: space-between;\n    text-align: center;\n    margin-top: -43px;\n    width: 108%;\n    margin-left: -4%;\n  }\n\n  .controls .player-controls button {\n    width: 34px;\n    margin: 0 0.125rem;\n  }\n\n  .labelbuttons {\n    cursor: pointer;\n    border: 0.5px solid gray;\n    border-radius: 9%;\n    height: 28px;\n    margin-left: 8px;\n  }\n\n  .controls .player-controls .play-control {\n    background: #2f3b44;\n    border: 0;\n    color: #a5b0b5;\n    padding: 0.5rem;\n    border-radius: 4px;\n    cursor: pointer;\n    font-weight: bold;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n  }\n\n  @media screen and (max-width: 1980px) {\n    .roi-info-container {\n      margin-top: -43px;\n      position: absolute;\n      width: 150px;\n      margin-left: -95px;\n    }\n\n    .roi-selector-delete-button {\n      position: absolute;\n      z-index: 233;\n      background: #e74c3c;\n      border: 0;\n      color: #ffffff;\n      padding: 0.5rem;\n      border-radius: 4px;\n      cursor: pointer;\n      font-weight: bold;\n      text-transform: uppercase;\n      letter-spacing: 0.05em;\n      width: 180px !important;\n      margin-left: -192px !important;\n    }\n\n    .roi-selector-delete-button:hover {\n      background: #c0392b;\n    }\n\n    .roi-info-button {\n      position: absolute;\n      z-index: 233;\n      background: #2f3b44;\n      border: 0;\n      color: #ffffff;\n      padding: 0.5rem;\n      border-radius: 4px;\n      cursor: pointer;\n      font-weight: bold;\n      text-transform: uppercase;\n      letter-spacing: 0.05em;\n      margin-left: 32px !important;\n      width: 75px !important;\n    }\n\n    .roi-info-button:hover {\n      background: #445562;\n    }\n  }\n\n  @media screen and (max-width: 1466px) {\n    .roi-info-container {\n      margin-top: -43px;\n      position: absolute;\n      width: 150px;\n      margin-left: -100px;\n    }\n\n    .roi-selector-delete-button {\n      position: absolute;\n      z-index: 233;\n      background: #e74c3c;\n      border: 0;\n      color: #ffffff;\n      padding: 0.5rem;\n      border-radius: 4px;\n      cursor: pointer;\n      font-weight: bold;\n      text-transform: uppercase;\n      letter-spacing: 0.05em;\n      width: 117px !important;\n      margin-left: -92px !important;\n    }\n\n    .roi-selector-delete-button:hover {\n      background: #c0392b;\n    }\n\n    .roi-info-button {\n      position: absolute;\n      z-index: 233;\n      background: #2f3b44;\n      border: 0;\n      color: #ffffff;\n      padding: 0.5rem;\n      border-radius: 4px;\n      cursor: pointer;\n      font-weight: bold;\n      text-transform: uppercase;\n      letter-spacing: 0.05em;\n      margin-left: 32px !important;\n      width: 51px !important;\n    }\n\n    .roi-info-button:hover {\n      background: #445562;\n    }\n  }\n\n\n\n  .videoPlayPuase {\n    position: absolute;\n    z-index: 233;\n  }\n\n  .roi-selector-cancel-button {\n    position: absolute;\n    z-index: 233;\n    background: #e74c3c;\n    border: 0;\n    color: #ffffff;\n    padding: 0.5rem;\n    border-radius: 4px;\n    cursor: pointer;\n    font-weight: bold;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n  }\n\n  .roi-selector-cancel-button:hover {\n    background: #c0392b;\n  }\n\n  .controls .player-controls .play-control:hover {\n    background: #445562;\n  }\n\n  .controls .player-controls .play-control:active {\n    color: #ffffff;\n  }\n\n  .controls .player-controls .seek-start {\n    background: #2f3b44;\n    border: 0;\n    color: #a5b0b5;\n    padding: 0.5rem;\n    border-radius: 4px;\n    cursor: pointer;\n    font-weight: bold;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n  }\n\n  .controls .player-controls .seek-start:hover {\n    background: #445562;\n  }\n\n  .controls .player-controls .seek-start:active {\n    color: #ffffff;\n  }\n\n  .controls .player-controls .seek-end {\n    background: #2f3b44;\n    border: 0;\n    color: #a5b0b5;\n    padding: 0.5rem;\n    border-radius: 4px;\n    cursor: pointer;\n    font-weight: bold;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n  }\n\n  .controls .player-controls .seek-end:hover {\n    background: #445562;\n  }\n\n  .controls .player-controls .seek-end:active {\n    color: #ffffff;\n  }\n\n  .controls .settings-control {\n    background: #2f3b44;\n    border: 0;\n    color: #a5b0b5;\n    padding: 0.5rem;\n    border-radius: 4px;\n    cursor: pointer;\n    font-weight: bold;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n  }\n\n  .controls .meta-downloader {\n    background: #2f3b44;\n    border: 0;\n    color: #a5b0b5;\n    padding: 0.5rem;\n    border-radius: 4px;\n    cursor: pointer;\n    font-weight: bold;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    position: absolute;\n    margin-top: -245px !important;\n  }\n\n  .analytic-chart-data {\n    background: #2f3b44;\n    border: 0;\n    color: #a5b0b5;\n    padding: 0.5rem;\n    border-radius: 4px;\n    cursor: pointer;\n    font-weight: bold;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    position: absolute;\n    margin-top: -200px !important;\n  }\n\n  .controls .settings-control:active {\n    color: #ffffff;\n  }\n\n  .controls .settings-control:hover {\n    background: #445562;\n  }\n\n  .controls .trim-control {\n    background: #0072cf;\n    border: 0;\n    color: #fff;\n    padding: 0.5rem;\n    border-radius: 4px;\n    cursor: pointer;\n    font-weight: bold;\n    text-transform: uppercase;\n    letter-spacing: 0.1em;\n  }\n\n  .controls .trim-control:hover {\n    background: #038eff;\n  }\n\n  .margined {\n    margin: 0em 0.3em;\n  }\n\n  .warning {\n    padding: 0.8em;\n    color: #da7f00;\n    background-color: #ffecd1;\n    border-radius: 0.3em;\n    border: 0.1em solid #f0ad4e;\n    margin: 1em;\n    justify-content: center;\n    text-align: center;\n  }\n\n  .thumbnail {\n    width: 20%;\n    height: auto;\n    justify-content: center;\n    align-items: center;\n    border: 0.2em solid black;\n    border-radius: 0.3em;\n  }\n\n  .marginVertical {\n    margin: 1.5em 0em;\n  }\n\n  .videoframeController {\n    display: flex;\n    flex-direction: column;\n    margin-top: 10px;\n    margin-left: 30px;\n    width: 40%;\n    /* padding-left: 24px; */\n  }\n\n  .progress_time {\n    position: absolute;\n    font-size: 12px;\n    margin-top: -14px;\n    columns: black;\n    background: white !important;\n    /* margin-left: 30%; */\n  }\n\n  .progress_time1 {\n    position: absolute;\n    font-size: 12px;\n    margin-top: -20px;\n    columns: black;\n    background: white !important;\n    /* margin-left: 30%; */\n  }\n\n  .progress_time1 .timeFrame {\n    font-size: 18px;\n    font-weight: bold;\n  }\n\n  .progress_time1 .timeFrameline {\n    margin: 0px;\n    font-size: 6px;\n    margin-top: 12px;\n    font-family: none;\n    font-weight: 900;\n  }\n\n  .progress_time .timeFrameline {\n    margin: 0px;\n    font-size: 6px;\n    margin-top: 12px;\n    font-family: none;\n    font-weight: 900;\n  }\n\n  .progress_time .timeFrame {\n    margin-top: -1px;\n    margin-bottom: 0px;\n    font-size: 12px;\n  }\n\n  .playbackControllContainer {\n    margin-bottom: 0px;\n    margin-top: 15px;\n    height: 5px;\n  }\n\n  .labelplaypauseControler {\n    background: transparent;\n    width: 26px;\n    padding-left: 6px;\n    border: none;\n    cursor: pointer;\n  }\n\n  /* toggle button */\n  .switch {\n    width: 60px;\n    height: 34px;\n    outline: none;\n    scale: 0.7;\n    margin-top: 8px;\n  }\n\n  .switch input {\n    position: absolute;\n  }\n\n  .slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #ccc;\n    -webkit-transition: 0.4s;\n    transition: 0.4s;\n    border-radius: 34px;\n  }\n\n  .slider:before {\n    position: absolute;\n    content: \"\";\n    height: 26px;\n    width: 26px;\n    left: 4px;\n    bottom: 4px;\n    background-color: white;\n    -webkit-transition: 0.4s;\n    transition: 0.4s;\n    border-radius: 50%;\n  }\n\n  input:checked + .slider {\n    background-color: #2196f3;\n  }\n\n  input:focus + .slider {\n    box-shadow: 0 0 1px #2196f3;\n  }\n\n  input:checked + .slider:before {\n    -webkit-transform: translateX(26px);\n    -ms-transform: translateX(26px);\n    transform: translateX(26px);\n  }\n\n  /* .containerForFrameEnable{\n    width: 300px;\n    height: 100px;\n  } */\n\n  .frameTimeLines {\n    position: absolute;\n    margin-top: -13px;\n    font-size: 9px;\n    margin-left: 22px;\n    z-index: 100;\n  }\n\n  .frameTimeLinesright {\n    position: absolute;\n    margin-top: -13px;\n    font-size: 9px;\n    z-index: 100;\n    margin-left: -30px;\n  }\n\n  .hmsframeInput {\n    position: absolute;\n    width: 85px;\n    height: 34px;\n    font-size: 20px;\n    margin-top: 3px;\n    z-index: 6 !important;\n  }\n\n  .hmsframeInputRight {\n    margin-left: -80px;\n  }\n\n  .hmsframeInputLeft {\n    margin-left: 80px;\n  }\n\n  .sublabelSelectorButton {\n    margin-top: 11px;\n    display: block;\n    width: 100%;\n    border-radius: 5px;\n    margin-bottom: 20px;\n  }\n\n  .labelSelector {\n    width: 100%;\n    height: 36px;\n    cursor: pointer;\n    margin-top: 8px;\n    margin-bottom: -6px;\n    border-radius: 4px;\n    border: 1px solid #ced4da;\n  }\n\n  table {\n    width: 350px;\n    height: 100px;\n    border-collapse: collapse;\n    border-collapse: collapse;\n    /*Entfernt die Standardabstände zwischen den Tabellenzellen */\n  }\n\n  thead {\n    background: rgb(153, 208, 240);\n  }\n\n  th,\n  td {\n    width: 70px;\n    text-align: left;\n    border: 1px solid #d6d6d6;\n  }\n\n  .tooltip {\n    position: relative;\n    display: inline-block;\n    border-bottom: 1px dotted black;\n  }\n\n  .tooltip .tooltiptext {\n    visibility: hidden;\n    width: 120px;\n    background-color: black;\n    color: #fff;\n    text-align: center;\n    border-radius: 6px;\n    padding: 5px 0;\n\n    /* Position the tooltip */\n    position: absolute;\n    z-index: 1;\n    bottom: 100%;\n    left: 50%;\n    margin-left: -60px;\n  }\n\n  .tooltip:hover .tooltiptext {\n    visibility: visible;\n  }\n\n\n  /* popup modal */\n  .modal {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 35%;\n    background-color: white;\n    border: none;\n\n  }\n\n  .modalContenContainer {\n    padding: 16px;\n    padding-bottom: 11%;\n  }\n\n  .modalHeadContainer {\n    display: flex;\n    justify-content: space-between;\n  }\n\n  .modalCloseButton {\n    height: 23px;\n    background: none;\n    border: none;\n    font-size: 19px;\n    cursor: pointer;\n  }\n\n  .modal p {\n    font-weight: 900;\n  }\n\n  .modalButtonsContainer {\n    width: 100%;\n    display: flex;\n    justify-content: stretch;\n  }\n\n  .modalSubmitButton {\n    width: 100%;\n    padding: 3%;\n    cursor: pointer;\n  }\n\n  .cancelButton {\n    background-color: gray;\n    border: 0.5px solid gray;\n  }\n\n  .submitButton {\n    background-color: #038eff;\n    border: 0.5px solid #038eff;\n    color: white;\n  }\n\n  .submitButton:hover {\n    background-color: #2980b9;\n    color: white;\n  }\n\n  .newLabelInputs {\n    display: flex;\n    flex-direction: column;\n    text-align: left;\n  }\n\n\n  /* Alert Box */\n\n  .alertImg {\n    margin-left: 3%;\n  }\n\n  #toast {\n    visibility: hidden;\n    border: 1px solid;\n    border-left: 10px solid;\n    height: 67px;\n    margin-left: 75%;\n    width: 20%;\n    background-color: #ffffff;\n    color: #000000;\n    text-align: center;\n    border-radius: 2px;\n    position: fixed;\n    z-index: 1301;\n    left: 0;\n    right: 0;\n    bottom: 30px;\n    font-size: 17px;\n  }\n\n  .toastCloser {\n    margin-top: -6%;\n    background: transparent;\n    border: none;\n  }\n\n  #toast.show {\n    visibility: visible;\n    -webkit-animation: fadein 0.5s, fadeout 0.5s 1s;\n    animation: fadein 0.5s, fadeout 0.5s 1.5s;\n  }\n\n  @-webkit-keyframes fadein {\n    from {\n      left: 30%;\n      opacity: 0;\n    }\n\n    to {\n      left: 0%;\n      opacity: 1;\n    }\n  }\n\n  @keyframes fadein {\n    from {\n      left: 30%;\n      opacity: 0;\n    }\n\n    to {\n      left: 0%;\n      opacity: 1;\n    }\n  }\n\n  @-webkit-keyframes fadeout {\n    from {\n      left: 0%;\n      opacity: 1;\n    }\n\n    to {\n      left: 30%;\n      opacity: 0;\n    }\n  }\n\n  @keyframes fadeout {\n    from {\n      left: 0%;\n      opacity: 1;\n    }\n\n    to {\n      left: 30%;\n      opacity: 0;\n    }\n  }\n\n  .messageheadContainer {\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    padding: 0%;\n    padding-top: 1%;\n    padding-left: 5%;\n    padding-bottom: 0%;\n  }\n\n  .toast-check {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 35px;\n    width: 35px;\n    background-color: #40f467;\n    border-radius: 50%;\n    color: #fff;\n    font-size: 20px;\n  }\n\n  .message {\n    display: flex;\n    flex-direction: column;\n    margin: 1px 20px 0px 7px;\n    text-align: left;\n    padding-left: 3%;\n  }\n\n  .message-text {\n    font-size: 20px;\n    font-weight: 600;\n  }\n\n  .text-1 {\n    color: #333;\n    margin-top: 2%;\n  }\n\n  .text-2 {\n    color: #666;\n    font-weight: 400;\n    font-size: 16px;\n  }\n\n  .toast-close {\n    position: absolute;\n    top: 10px;\n    right: 15px;\n    padding: 5px;\n    cursor: pointer;\n    opacity: 0.7;\n  }\n\n  .toast-close:hover {\n    opacity: 1;\n  }\n\n  .annotateSubmitButton {\n    margin-top: -42px;\n    position: absolute;\n    width: 140px;\n    height: 40px;\n    background: #16a436;\n    border: 1px #def4e0;\n    color: white;\n    border-radius: 3px;\n    z-index: 202;\n  }\n\n  .annotateSubmitButton:hover,\n  .annotateSubmitButton:active {\n    background: #0b7323;\n    color: white;\n  }\n\n  .annotatesubmitcontainer {\n    margin-top: 0.5%;\n    position: absolute;\n  }\n}\n\n.ContainerForTheAnnoatatorModal {\n  .MuiBackdrop-root {\n    background: none;\n  }\n\n  .MuiBox-root {\n    width: 50%;\n  }\n\n  .alertMessage {\n    padding-left: 30px;\n    padding-right: 30px;\n  }\n\n  .alertMessage-for-shortcuts {\n    margin-top: 30vh;\n    padding-left: 30px;\n    padding-right: 30px;\n  }\n\n  .confirmationModalbuttonContainer {\n    width: 100%;\n    display: flex;\n  }\n\n  .confirmationButtons {\n    width: 50%;\n    height: 47px;\n    border: none;\n  }\n\n  .confirmationCancel {\n    background: #ffd6d6;\n    border: #FFE5E5;\n    color: #ff6b6b;\n  }\n\n  .confirmationCancel:hover,\n  .confirmationCancel:active {\n    background: #fc5858;\n    color: white;\n  }\n\n  .confirmationYes {\n    background: #0b7323;\n    border: 1px #def4e0;\n    color: #16a436;\n  }\n\n  .confirmationYes:hover,\n  .confirmationYes:active {\n    background: #16a436;\n    color: white;\n  }\n\n  .containerForRoiModal {\n    padding: 0px 22px;\n\n    .heading {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      margin-bottom: 10px;\n    }\n\n    .editButton {\n      cursor: pointer;\n      background-color: transparent;\n      color: white;\n      border: none;\n      padding: 0px;\n      font-size: 23px;\n      width: 29px;\n    }\n\n    .textareaContainer {\n      display: flex;\n      flex-direction: column;\n      gap: 10px;\n    }\n\n    .textarea {\n      width: 100%;\n      padding: 10px;\n      border-radius: 4px;\n      border: 1px solid #ccc;\n      height: 67px;\n    }\n\n    .copyButton {\n      cursor: pointer;\n      background-color: #28a745;\n      color: white;\n      border: none;\n      border-radius: 4px;\n      padding: 5px 10px;\n      align-self: flex-end;\n    }\n\n    .buttonContainer {\n      display: flex;\n      justify-content: space-between;\n    }\n\n    .saveButton {\n      cursor: pointer;\n      background-color: #007bff;\n      color: white;\n      border: none;\n      border-radius: 4px;\n      padding: 5px 10px;\n    }\n\n    .closeButton {\n      cursor: pointer;\n      background-color: #dc3545;\n      color: white;\n      border: none;\n      border-radius: 4px;\n      padding: 5px 10px;\n    }\n\n    .row {\n      display: flex;\n      justify-content: space-between;\n      margin-bottom: 10px;\n    }\n\n    .fieldBox {\n      flex: 1;\n      border: 1px solid #ccc;\n      padding: 10px;\n      border-radius: 4px;\n      margin-right: 5px;\n      background-color: #fff;\n      text-align: center;\n    }\n\n  }\n\n  .frame_export_inp_container {\n    margin-top: 20px;\n  }\n\n  .frame_export_header {\n    text-align: center;\n  }\n  .labels-key-information{\n    font-size: 14px;\n    color: #333;\n    margin-bottom: 10px;\n  }\n\n  .labels-info-container {\n    max-height: 70vh;\n    overflow-y: scroll;\n  }\n\n  .sublabel-table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-top: 10px;\n    overflow: hidden;\n\n    tr,\n    td,\n    th {\n      border: 1px solid #ddd;\n      padding: 8px;\n    }\n\n    .left-cells {\n      width: 30%;\n      text-align: left;\n    }\n\n    .right-cells {\n      width: 70%;\n      text-align: left;\n    }\n\n    .access-key-controll {\n      width: 25px;\n      height: 25px;\n    }\n    .access-key-input{\n      width: 30%;\n    }\n  }\n\n  .modal-dropdown {\n    width: 90%;\n    margin-left: 5%;\n    padding: 7px;\n    margin-bottom: 4%;\n    border-radius: 5px;\n    background: white;\n  }\n\n  .dropdown-container {\n    width: 100%;\n    margin: 5%;\n\n    .dropdown-input {\n      width: 90%;\n    }\n\n    .dropdown-option {\n      overflow: hidden;\n    }\n\n    .dropdown-option:hover {\n      background-color: #f0f0f0;\n    }\n  }\n\n  .drop-down-menu {\n    position: absolute;\n    width: 90%;\n    max-height: 200px;\n    overflow: auto;\n  }\n\n  .label-selector-dropdown {\n    width: 90%;\n    margin: 5%;\n    /* border-radius: 5px; */\n  }\n\n  .modal-box {\n    height: auto;\n  }\n\n  .close-icon {\n    position: absolute;\n    right: 10px;\n    top: 10px;\n    cursor: pointer;\n    font-size: 20px;\n    color: #333;\n  }\n\n  .frame_download_loader {\n    width: 100%;\n    text-align: center;\n    margin-top: 50px;\n  }\n\n  .frame_interval_input {\n    width: 100%;\n    margin: 1%;\n    padding: 5px;\n    border: 1px solid;\n    border-radius: 3px;\n  }\n\n  .frame_download_submit_button {\n    background: #d5d8d8;\n    border: #d5d8d8;\n    min-width: 180px;\n    width: 100%;\n    margin: 1%;\n    padding: 5px;\n    color: #343636;\n    border-radius: 3px;\n    height: 39px;\n  }\n}\n\n.ContainerForChartDataModal {\n  .MuiBackdrop-root {\n    background: none;\n  }\n\n  .MuiBox-root {\n    width: 50%;\n  }\n\n  .analyticTableHeader {\n    display: flex;\n    justify-content: space-between;\n\n  }\n\n  /* Basic table styling */\n  table {\n    width: 100%;\n    border-collapse: collapse;\n    margin: 20px 0;\n    font-size: 1em;\n    font-family: Arial, sans-serif;\n    text-align: left;\n  }\n\n  th,\n  td {\n    padding: 12px 15px;\n    border: 1px solid #ddd;\n  }\n\n  /* Table header styling */\n  th {\n    background-color: #6bd0ff;\n    color: white;\n  }\n\n  /* Hover effect on rows */\n  tr:hover {\n    background-color: #f1f1f1;\n    cursor: pointer;\n  }\n\n  /* Export button styling */\n  button {\n    margin: 10px 0;\n    padding: 8px 12px;\n    background-color: #d6f5ff;\n    color: #6bd0ff;\n    border: none;\n    cursor: pointer;\n    font-size: 1em;\n  }\n\n  button:hover {\n    background-color: #6bd0ff;\n    color: white;\n  }\n\n}\n\n.autoCompleteComponent {\n  margin-top: 2%;\n}\n\n.MuiOutlinedInput-root {\n  padding: 5px 9px !important;\n}\n\n::-webkit-scrollbar {\n  width: 3px;\n  height: 3px\n}\n\n::-webkit-scrollbar-button {\n  background: #ccc\n}\n\n::-webkit-scrollbar-track-piece {\n  background: #eee\n}\n\n::-webkit-scrollbar-thumb {\n  background: #888\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
